import Navbar from "../home/components/Navbar";
import Footer from "../home/components/Footer";
import { VISA_LIST } from "../../mocks/visas";
import SeoMeta from "../../components/base/SeoMeta";

const BASE_URL = (import.meta.env.VITE_SITE_URL as string) || "https://flightfare.pk";

const VISA_JSON_LD = [
  {
    "@context": "https://schema.org",
    "@type": "WebPage",
    "name": "Tourist & Visit Visa Services Pakistan – flightfare.pk",
    "url": `${BASE_URL}/visa`,
    "description": "Get tourist and visit visa assistance in Pakistan with flightfare.pk. Professional visa application services for Schengen, UK, USA, UAE, Malaysia and more."
  },
  {
    "@context": "https://schema.org",
    "@type": "Service",
    "name": "Tourist & Visit Visa Assistance Pakistan",
    "serviceType": "Visa Assistance",
    "provider": {
      "@type": "TravelAgency",
      "name": "flightfare.pk",
      "url": BASE_URL,
      "address": {
        "@type": "PostalAddress",
        "addressLocality": "Bahria Town, Lahore",
        "addressRegion": "Punjab",
        "addressCountry": "PK"
      }
    },
    "areaServed": "PK",
    "description": "Expert visa assistance for tourist and visit visas from Pakistan. We handle Schengen, UK, USA, UAE, Malaysia, Thailand, Turkey and many more countries.",
    "offers": {
      "@type": "AggregateOffer",
      "priceCurrency": "PKR",
      "availability": "https://schema.org/InStock"
    }
  }
];

export default function VisaPage() {
  return (
    <div className="min-h-screen bg-white">
      <Navbar />
      <SeoMeta
        title="Tourist & Visit Visa Assistance Pakistan – Schengen, UK, USA, UAE | flightfare.pk"
        description="Apply for tourist and visit visas with flightfare.pk Pakistan. Expert visa assistance for Schengen, UK, USA, UAE, Malaysia, Turkey and more. Fast, professional visa services from Lahore."
        keywords="visa assistance Pakistan, tourist visa Pakistan, Schengen visa Pakistan, UK visa Pakistan, UAE visa Lahore, USA visa assistance Pakistan, visit visa Pakistan"
        canonical="/visa"
        jsonLd={VISA_JSON_LD}
      />

      {/* Hero Banner */}
      <div className="pt-16">
        <div className="relative overflow-hidden" style={{ background: "linear-gradient(135deg, #0891b2 0%, #06b6d4 40%, #22d3ee 70%, #a3e8ef 100%)" }}>
          <div className="absolute top-0 left-0 right-0 h-2 bg-amber-400" />
          <div className="absolute top-6 right-24 w-10 h-10 rounded-full border-2 border-white/30" />
          <div className="absolute top-16 right-64 w-5 h-5 rounded-full border border-white/20" />
          <div className="absolute bottom-8 left-16 w-8 h-8 rounded-full border border-white/20" />
          <div className="absolute bottom-16 left-48 w-4 h-4 rounded-full border border-white/30" />
          <div className="max-w-7xl mx-auto px-4 py-12 md:py-16 flex flex-col md:flex-row items-start md:items-center justify-between gap-6">
            <div className="max-w-xl">
              <h1 className="text-3xl font-extrabold text-white leading-tight tracking-wide uppercase">
                Tourist and Visit Visas
              </h1>
              <p className="text-white/90 text-sm mt-3 leading-relaxed">
                Get comprehensive information on tourist and visit visas in Pakistan with flightfare.pk.
              </p>
            </div>
            <div className="hidden md:block flex-shrink-0">
              <img
                src="https://public.readdy.ai/ai/img_res/be2a280d84f9836379d958ba346a4a8e.jpg"
                alt="Visa Services"
                className="w-64 h-52 object-contain object-top"
              />
            </div>
          </div>
        </div>
      </div>

      {/* Offered Services */}
      <section className="py-14 bg-white">
        <div className="max-w-7xl mx-auto px-4 md:px-6">
          <h2 className="text-2xl font-bold text-gray-900 text-center mb-8">Offered Services</h2>
          <div className="grid grid-cols-2 md:grid-cols-4 gap-4 md:gap-5">
            {VISA_LIST.map((visa) => (
              <a
                key={visa.slug}
                href={`/visa/${visa.slug}`}
                className="block rounded-lg overflow-hidden border border-gray-200 cursor-pointer hover:border-cyan-300 transition-all group"
              >
                <div className="w-full h-44">
                  <img
                    src={visa.bannerImage}
                    alt={visa.title}
                    className="w-full h-full object-cover object-top group-hover:scale-105 transition-transform duration-300"
                  />
                </div>
                <div className="p-4">
                  <p className="text-sm font-bold text-gray-900 mb-1">{visa.title}</p>
                  <p className="text-xs text-gray-500 leading-relaxed mb-3 line-clamp-2">{visa.description}</p>
                  <div className="flex items-center justify-between">
                    <p className="text-sm font-semibold text-green-600">
                      PKR <span className="font-bold">{visa.price}</span>
                    </p>
                    <span className="text-xs text-cyan-600 font-semibold flex items-center gap-0.5 cursor-pointer">
                      Apply <i className="ri-arrow-right-line text-xs"></i>
                    </span>
                  </div>
                </div>
              </a>
            ))}
          </div>
        </div>
      </section>

      {/* Description */}
      <section className="py-10 bg-white border-t border-gray-100">
        <div className="max-w-7xl mx-auto px-4 md:px-6 space-y-4">
          <p className="text-sm text-gray-600 leading-relaxed">
            At flightfare.pk, we understand the importance of a smooth visa application process for your travel plans. Whether you are planning to explore new destinations or visit family and friends abroad, our comprehensive visa services cover a wide range of countries and visa types. We offer personalised guidance tailored to your specific needs, helping you prepare your application accurately and efficiently.
          </p>
          <p className="text-sm text-gray-600 leading-relaxed">
            Choose flightfare.pk for reliable and professional tourist and visit visa services in Pakistan. Our experienced team stays updated with the latest visa regulations and procedures, ensuring you receive accurate and timely information. With our commitment to excellence and customer satisfaction, you can trust us to handle your visa application with the utmost care and professionalism. Start your journey with confidence by partnering with flightfare.pk for all your visa needs.
          </p>
        </div>
      </section>

      <Footer />
    </div>
  );
}
